import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, Circle } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default icon paths (Leaflet in React)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const colorHex = {
  primary: "#0057FF",
  secondary: "#00C853",
  destructive: "#FF3B30",
  accent: "#FF6B00",
};

function makeIcon(color = "primary") {
  const c = colorHex[color] || color;
  return L.divIcon({
    html: `<div style="width:22px;height:22px;background:${c};border:3px solid #fff;border-radius:9999px;box-shadow:0 4px 10px rgba(0,0,0,.35);"></div>`,
    className: "",
    iconSize: [22, 22],
    iconAnchor: [11, 11],
  });
}

export default function LiveMap({ points = [], center, zoom = 13, showCircles = false }) {
  const first = points[0];
  const c = center || (first ? [first.lat, first.lng] : [20, 0]);
  return (
    <MapContainer center={c} zoom={zoom} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; OpenStreetMap'
      />
      {points.map((p, i) => (
        <React.Fragment key={i}>
          <Marker position={[p.lat, p.lng]} icon={makeIcon(p.color || "primary")}>
            {p.label && <Popup>{p.label}</Popup>}
          </Marker>
          {showCircles && (
            <Circle center={[p.lat, p.lng]} radius={p.radius || 250} pathOptions={{ color: colorHex[p.color] || colorHex.primary, weight: 1, fillOpacity: 0.08 }} />
          )}
        </React.Fragment>
      ))}
    </MapContainer>
  );
}
